import React from 'react';
import VehicleDetailsForm from '../Components/VehicleDetailsForm';

const VehicleDetailsPage = () => {
  return (
    <VehicleDetailsForm
      isOpen
      mode="page"
      pageBackPath="/"
      pageBackLabel="Back to Services"
      pageTitleText="Vehicle Details Form"
      pageCompletionPath="/"
    />
  );
};

export default VehicleDetailsPage;


